function copy_arr(arg) {
    if (!arg) {
        return arg;
    }
    let v;
    let obj = Array.isArray(arg) ? [] : {};
    for (const k in arg) {
        v = arg[k];
        obj[k] = (typeof v === "object") ? copy_arr(v) : v;
    }
    return obj;
}
function loadArgs($arguments){
    return Array.from($arguments).flat();
    }
function loadArgNumbers($args){
    let args = loadArgs($args).flat(2),float=false;
    for(let i = 0; i < args.length; i++){
        float = float || parseFloat(args[i]) != parseInt(args[i])
    }
    args = float ? args.filterFloat() : args.filterInt();
    return args;
    }


exports.isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
exports.json = {
    isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    },
    replacer: function(match, pIndent, pKey, pVal, pEnd) {
        var key = '<span class=json-key>';
        var val = '<span class=json-value>';
        var str = '<span class=json-string>';
        var r = pIndent || '';
        if (pKey) {
            r = r + key + pKey.replace(/[": ]/g, '') + '</span>: ';
        }
        if (pVal) {
           r = r + (pVal[0] == '"' ? str : val) + pVal + '</span>';
        }
       return r + (pEnd || '');
    },
    prettyPrint: function(obj) {
        var jsonLine = /^( *)("[\w]+": )?("[^"]*"|[\w.+-]*)?([,[{])?$/mg;
        return JSON.stringify(obj, null, 3)
            .replace(/&/g, '&amp;').replace(/\\"/g, '&quot;')
            .replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(jsonLine, this.replacer);
    }
}
exports.alt = function(){
    let  args = loadArgs(arguments), i = 0;
    while(i < args.length - 1 && (args[i] == undefined || args[i] == null || args[i] == '')){
        i++;
    }
    return args[i];
    }
exports.alt_0 = function(){
    let  args = loadArgs(arguments), i = 0;
    while(i < args.length && (args[i] == undefined || args[i] == null || args[i] == '' || args[i] == 0)){
        i++;
    }
    return args[i];
    }
exports.addDaysToDate = function  (date, n) {
    const d = new Date(date);
    d.setDate(d.getDate() + n);
    return d.toISOString().split('T')[0];
    }
exports.breakExp = function (string) {
    return "<br><div class='ml-4'>"+string+"</div>";
    }
exports.check_brackets = function (tab){
    let res = tab.map((el, i) => {
        return count_occ(el, '(') + i === count_occ(el, ')');
    });
    }
exports.copy_arr = function (arg) {
    return copy_arr(arg);
    };
exports.count_occ = function (str,sbtr){
    let reg = new RegExp(sbtr,'g');
    return (str.match(reg) || []).length;
    }
exports.dayMonth = function (day) {
    switch (Number(day)) {
        case 0:
            return 'start';
            break;
            case 1:
            return '1<sup>st</sup>';
            break;
            case 2:
            return '2<sup>nd</sup>';
            break;
            case 3:
            return '3<sup>rd</sup>';
            break;
            default:
            return day + '<sup>th</sup>';
            break;
        }
    }
exports.factors = function (nbre){
    let res = [];
    for(let i = 2; i <= nbre / 2; i++){
        if(nbre % i == 0){
            res.push(i);
        }
    }
    res.push(nbre);
    return res;
    }
exports.fixed = function (nbre1, operds) {
    let operands = operds.filter(Number), decs = operands.map(el => (el.toString().split('.')[1] || '').length);
    if(Math.max(...decs) == 0){
        return parseInt(nbre1);
    }else{
        return parseFloat(nbre1).toFixed(Math.max(...decs) == 0);
    }
    }
exports.focus = function (id) {
    let elem = document.getElementById(id);
    if(elem){
        elem.focus();
    }
    }
exports.getCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
    }
exports.is_fraction = function (val){
    if(typeof val === 'object'){
        if(val.is_fraction){
            return true;
        }
        if(val.hasOwnProperty('num') && val.hasOwnProperty('den')){
            return true;
        }
    }else{
        if(typeof val == 'string'){
            let parts = val.split('/');
            if(parts.length <= 1 || parts.length > 2 || Number(parts[1]) === 0){
                return false
            }else return true;
        }
    }
    }
exports.isImage = function (filename) {
    var ext = getExtension(filename);
    switch (ext.toLowerCase()) {
        case 'jpg':
        case 'gif':
        case 'bmp':
        case 'png':
      //etc
      return true;
  }
  return false;
}
exports.isValidOnlyExcept = function (obj = {}, find){
    if(obj.hasOwnProperty('only')){
        return obj.only.includes(find);
    }else if(obj.hasOwnProperty('except')){
        return !obj.except.includes(find);
    }
    return true;
}

exports.k_notation = function(nbre){
}
exports.load_settings = function (type, number, index =-1, min_in = 0, max_in = 20){
    let num = number.count || number, tab = [],
    number1 = (number instanceof Object) ? '' : '__num1____num2__',
    min = number.min || '__number1__-3',
    max = number.max || '__number1__+3',
    v = [
    {varName: "index", type: "int", constraints: "bt:" + min_in + "||" + max_in},
    {varName: "num1", type: "int", constraints: "bt:1||9"},
    {varName: "num2", type: "int", constraints: "bt:3||7"},
    {varName: 'count', constraints: 'in:' + num}
    ];
    for(let i = 0; i < num; i++){
        tab.push(i + 1);
        v.push(
        {
            varName: type + (i + 1),
            type: type,
            diff: v.map(el => '__' + el.varName + '__').join('||'),
            constraints: index ? ('index:__index__+' + i) : undefined,
        },
        {
            varName: 'number' + (i + 1),
            type: 'int',
            constraints: i == 0 && !(number instanceof Object) ? '__num1____num2__' : 'bt:' + min + '||' + max,
            diff: tab.slice(0, -1).map((el) => '__number' + el + '__').join('||'),
        }
        );
    }
    return {v: v, tab: tab}
    }
exports.load_image = function (img_, id, width=150,height){
    let img = new Image(width, height || width),
    div = document.getElementById(id);
    img.src = img_.src;
    img.className = 'avatar';
    if(div != null){
        div.innerHTML = "";
        div.appendChild(img);
    }
    }
exports.load_img_to_div = function (ev,id_div,size=150){
    let files = ev.target.files || ev.dataTransfer.files, d = files[0];
    if(!d) {
        return 0;
    }
    let g = ev.target.getAttribute("accept"),
    accepted = false,
    valid = true,
    errors = {
        mimeType: false,
        maxSize: false,
        width: false,
        minWidth: false,
        maxWidth: false,
        height: false,
        minHeight: false,
        maxHeight: false
    };

    if(g){
        var h = g.split(/[,|]/), c;
        for (c in h) {
            c = $.trim(c);
            if(d.type === c){
                accepted = true;
                return false
            }
            if(c.indexOf("/*") !== false){
                var a = c.replace("/*",""), b=d.type.replace(/(\/.*)$/g,"");
                if(a === b){
                    accepted = true;
                    return false
                }
            }
        }
        if(accepted === false){
            errors.mimeType = true
        }
    }else{
        accepted = true
    }

    var j = new FileReader(d);
    j.readAsDataURL(d);
    j.onload = function(e){
        var a = new Image(), isImage;
        d.data = e.target.result;
        a.src = d.data;
        load_image(a, id_div, size);
    }
    }
exports.loadArgNumbers = function ($args){
    return loadArgNumbers($args);
    }
exports.loadArgs = function ($arguments){
    return loadArgs($arguments);
    }
exports.only_except = function (tab, find){
    return tab.filter(el => {
        if(el.hasOwnProperty('only')){
            return el.only.includes(find);
        }else if(el.hasOwnProperty('except')){
            return !el.except.includes(find);
        }
        return true;
    });
    }
exports.pgcd = function (argument) {
    let args = loadArgs(arguments).flat().filterInt();
    if(args.length == 1){
        return args[0];
    }
    let x = Math.abs(args[0]), y = pgcd(args.slice(1));
    while(y) {
        var t = y;
        y = x % y;
        x = t;
    }
    return x;
    }
exports.ppcm = function () {
    let args = loadArgs(arguments).filterInt(), decomposes, res = 1;
    decomposes = args.map(el => Number(el).decompose()).flat();
    res = decomposes.filter(elt => {
        return elt.p == decomposes.filter(elem => elem.num == elt.num).map(elem=>elem.p).max();
    }).map(elt=>Math.pow(elt.num, elt.p)).filter((v, i, a) => a.indexOf(v) === i).reduce((a,b)=>a*b,1);
    return res;
    }
function read_notation(nbre){
    if(nbre % 1 > 0){
        return read_notation(nbre.toString().split('.')[0]) + "." + (nbre.toString().split(".")[1]);
    }
    if(nbre > 1000){
        return read_notation(parseInt(nbre / 1000)) + ',' + ('000' + nbre % 1000).slice(-3);
    }else{
        return nbre.toString();
    }
    }
exports.read_notation = function (nbre){
    return read_notation(nbre);
    }
exports.rn = function (val1, val2, precision = 0){
    let min = Math.min(val1, val2), max = Math.max(val1, val2);
    if(precision == 0){
        return parseInt(Math.random() * (max - min) + min);
    }
    return parseFloat(Math.random() * (max - min) + min).toFixed(precision);
    }
exports.setCookie = function (name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    let cookie = name + "=" + (value || "")  + expires + "; path=/";
    document.cookie = cookie;
    }
exports.strip_tags = function (str){
    // Remove all html tags from a string
    let div = document.createElement("div");
    div.innerHTML = str;
    return div.textContent || div.innerText || "";
    }

exports.table = function (options) {
    let obj,rows = [], tr, header, body, table, title = '';
    for (obj of options.headers) {
        rows.push(tag('th', obj, {class: '', scope: 'col'}));
    }
    tr = tag('tr', rows.join(' '));
    header = tag('thead', tr, {class: 'head-table'});
    rows = [];
    for (obj of options.rows) {
        let row = [];
        let datas_row = "";
        for (const col in obj) {
            row.push(tag('td', obj[col]));
            datas_row += "&" + obj[col] + "&";
        }
        rows.push(tag('tr', row.join(''),
            {
                ':class':"[\"line\",{good:(truth||fail)&&\"" + datas_row + "\".includes(\"&\"+solution+\"&\"), fail:\"" + datas_row + "\".includes(\"&\"+submited+\"&\")&&fail}]"
            }
        ));
    }
    body = tag('tbody', rows.join(''));
    if(options.hasOwnProperty('title')){
        title = tag('div', options.title, {class: 'table-tilte'});
    }
    table = tag('table', header + body, Object.assign(options.table_attributes));
    return tag('div', title + table, Object.assign(options.table_attributes));
    }
exports.tag = function (tag,value,options={}){
    let tag_name = "<" + tag, obj;
    for (obj in options) {
        tag_name += " " + obj + "='" + options[obj] + "'";
    }
    tag_name += ">" + value + "</" + tag + ">";
    return tag_name;
    }
exports.txt_danger = function (txt){
    return "<span class='text-danger'>" + txt + "</span>";
    }